import { LocalDateType } from '@app/models';
import {gql} from 'apollo-angular';

export interface ValidityPeriod {
  numberOfDays?: number;
  periodStart: LocalDateType;
  periodEnd: LocalDateType;
  periodStartInPast?: boolean;
  periodEndInPast?: boolean;
}

export const validityPeriodDetailed = gql`
  fragment validityPeriodDetailed on ValidityPeriod {
    periodStart
    periodEnd
  }
`;
